import axios from "axios";
import authentication from "@/authentication";

const courierConfigService = {
  baseUrl: process.env.VUE_APP_API_COURIER_SERVICE_BASE,
  async getCouriers() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/Get`, {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  },
  async saveCourier(courier) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/SaveConfig`, JSON.stringify(courier), {
        headers: { Authorization: `Bearer ${authentication.getToken()}` }
      })
      .then(response => {
        return response.data;
      });
  },
  async getServices(user, pass, endpoint) {
    await authentication.isAuthenticated();
    return axios
      .post(
        `${this.baseUrl}/GetServices?u=${user}&p=${pass}&ep=${endpoint}`,
        {
          Endpoint: endpoint,
          Password: pass,
          UserName: user
        },
        {
          headers: { Authorization: `Bearer ${authentication.getToken()}` }
        }
      )
      .then(function(response) {
        return response.data;
      });
  }
};
export default courierConfigService;
